import React, { useEffect, useRef, useState } from "react";
import { formatDate } from "../../../../../../utils/commonFunctions";
import { Card, message } from "antd";
import swal from "sweetalert";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import ReactLoading from "react-loading";
import {
  isNameValid,
  isPhoneValid,
  isEmailValid,
  isAadharValid,
  isAlphanumeric,
} from "./commonfunctions";
import useAxios from "../../../../../../hooks/useAxios";

function Form11({
  form,
  filledForm,
  getAllJoiningFilledForms,
  aadharDetails,
  metaData,
  setForm11PreviewData,
  setActivePanel,
  application,
  setIsFieldTouch,
}) {
  let row = 0;
  let another_row = 0;
  let _aadhar = aadharDetails || {};
  const IS_DISABLE =
    filledForm?.formStatusByHR === false
      ? !application?.candidateSignatureStatus
        ? true
        : false
      : false;
  const DOB = application?.responses?.find(
    (item) => item?.label === "Date of Birth"
  )?.value;

  const AADHAR_GENDER = _aadhar?.aadharVerificationDetails?.data?.gender || "";

  const FORM_GENDER =
    application?.responses?.find((item) => item?.label === "Gender")?.value ||
    "";

  const GENDER = AADHAR_GENDER
    ? AADHAR_GENDER === "M"
      ? "male"
      : AADHAR_GENDER === "F"
      ? "female"
      : ""
    : FORM_GENDER
    ? FORM_GENDER?.toLowerCase()
    : "";

  const { id } = useParams();
  const api = useAxios();
  const [fatherOrSpouse, setFatherOrSpouse] = useState(
    filledForm?.documentDetails?.fatherOrSpouse === undefined
      ? true
      : filledForm?.documentDetails?.fatherOrSpouse
  );
  const [father, setFather] = useState(
    filledForm?.documentDetails?.father_name ||
      metaData?.father_name?.trim() ||
      _aadhar?.aadharVerificationDetails?.data?.care_of
        ?.replace(/^[A-Za-z]+\/[A-Za-z]+:?\s+/i, "")
        .trim() ||
      ""
  );
  const [spouse, setSpouse] = useState(
    filledForm?.documentDetails?.spouse_name ||
      _aadhar?.aadharVerificationDetails?.data?.care_of
        ?.replace(/^[A-Za-z]+\/[A-Za-z]+:?\s+/i, "")
        .trim() ||
      metaData?.spouse_name ||
      ""
  );
  const [accountNumber, setAccountNumber] = useState(
    filledForm?.documentDetails?.accountNumber || metaData?.bank_acc_no || ""
  );
  const [nominees, setNominees] = useState(
    !filledForm?.documentDetails
      ? [
          {
            name_of_establishment: "",
            ppo_number: "",
            ncp_days: "",
            date_of_joining: "",
            date_of_exit: "",
            universal_account_number: "",
            pf_account_number: "",
            scheme_certificate: "",
          },
        ]
      : [...filledForm?.documentDetails?.nominees]
  );

  const [pensionnominees, setPensionnominees] = useState(
    !filledForm?.documentDetails
      ? [
          {
            name_and_address_of_trust: "",
            ncp_days: "",
            date_of_joining: "",
            date_of_exit: "",
            universal_account_number: "",
            eps_account_number: "",
            scheme_certificate: "",
          },
        ]
      : [...filledForm?.documentDetails?.pensionnominees]
  );

  const [ifcCode, setIfcCode] = useState(
    filledForm?.documentDetails?.ifcCode || metaData?.ifsc_code || ""
  );
  const [unexempted, setUnexempted] = useState(
    filledForm?.documentDetails?.unexempted || "no"
  );
  const [exempted, setExempted] = useState(
    filledForm?.documentDetails?.exempted || "no"
  );
  const [formData, setFormData] = useState({
    name:
      filledForm?.documentDetails?.name ||
      _aadhar?.aadharVerificationDetails?.data?.full_name ||
      (metaData?.first_name || metaData?.last_name
        ? `${metaData?.first_name} ${metaData?.last_name}`
        : undefined) ||
      "",
    dob:
      filledForm?.documentDetails?.dob ||
      _aadhar?.aadharVerificationDetails?.data?.dob ||
      DOB ||
      "",
    marital_status:
      filledForm?.documentDetails?.marital_status ||
      (metaData?.marital_status?.toLowerCase() === "single"
        ? "unmarried"
        : metaData?.marital_status?.toLowerCase() === "widower"
        ? "widow"
        : metaData?.marital_status?.toLowerCase() || ""),
    sex:
      filledForm?.documentDetails?.sex ||
      GENDER ||
      metaData?.gender?.toLowerCase() ||
      "",
    email: filledForm?.documentDetails?.email || metaData?.email || "",
    mobile_number:
      filledForm?.documentDetails?.mobile_number || metaData?.contact_no || "",
    aadhar_number:
      filledForm?.documentDetails?.aadhar_number || metaData?.aadhar_no || "",
    pan_number:
      filledForm?.documentDetails?.pan_number || metaData?.pan_no || "",
    // place: filledForm?.documentDetails?.place || "",
    provident_fund_scheme:
      filledForm?.documentDetails?.provident_fund_scheme || "",
    pension_scheme: filledForm?.documentDetails?.pension_scheme || "",
    withdrawn_accumulations:
      filledForm?.documentDetails?.withdrawn_accumulations || "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({});
  const [nomineeError, setNomineeError] = useState({});
  const [pensionnomineeError, setPensionnomineeError] = useState({});

  const handleChange = (e) => {
    setIsFieldTouch(true);
    const { name, value } = e.target;
    if (name === "provident_fund_scheme") {
      if (value === "no") {
        setFormData((prev) => ({
          ...prev,
          [name]: value,
          withdrawn_accumulations: "",
        }));
        return;
      }
    }
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateNominee = () => {
    for (let i = 0; i < nominees.length; i++) {
      let nominee = nominees[i];
      if (nominee) {
        let keys = Object.keys(nominee);
        for (let j = 0; j < keys.length; j++) {
          let key = keys[j];
          if (
            nominee[key] === "" &&
            key !== "scheme_certificate" &&
            key !== "ppo_number" &&
            key !== "ncp_days"
          ) {
            return true;
          }
        }
      }
    }
    return false;
  };

  const validatePensionNominee = () => {
    for (let i = 0; i < pensionnominees.length; i++) {
      let nominee = pensionnominees[i];
      if (nominee) {
        let keys = Object.keys(nominee);
        for (let j = 0; j < keys.length; j++) {
          let key = keys[j];
          if (
            nominee[key] === "" &&
            key !== "scheme_certificate" &&
            key !== "ncp_days"
          ) {
            return true;
          }
        }
      }
    }
    return false;
  };

  const isFormDataEmpty = () => {
    for (let key in formData) {
      if (
        formData[key].trim() === "" &&
        key !== "withdrawn_accumulations" &&
        key !== "pan_number"
      ) {
        return true;
      }
    }
    return false;
  };

  const addMore = (e) => {
    setNominees((prev) => {
      return [
        ...prev,
        {
          name_of_establishment: "",
          ppo_number: "",
          ncp_days: "",
          date_of_joining: "",
          date_of_exit: "",
          universal_account_number: "",
          pf_account_number: "",
          scheme_certificate: "",
        },
      ];
    });
  };

  const pensionaddMore = (e) => {
    setPensionnominees((prev) => {
      return [
        ...prev,
        {
          name_and_address_of_trust: "",
          ncp_days: "",
          date_of_joining: "",
          date_of_exit: "",
          universal_account_number: "",
          eps_account_number: "",
          scheme_certificate: "",
        },
      ];
    });
  };

  const deleteNominee = (_index) => {
    setNominees((prev) => {
      let arr = [...prev];
      // arr.splice(_index,1)
      arr[_index] = null;
      return [...arr];
    });

    for (let key in nomineeError) {
      if (key.endsWith(_index)) {
        delete nomineeError[key];
      }
    }
  };

  const deletePensionNominee = (_index) => {
    setPensionnominees((prev) => {
      let arr = [...prev];
      // arr.splice(_index,1)
      arr[_index] = null;
      return [...arr];
    });

    for (let key in pensionnomineeError) {
      if (key.endsWith(_index)) {
        delete pensionnomineeError[key];
      }
    }
  };

  const handleChangeNominee = (e, _index) => {
    setIsFieldTouch(true);
    const { name, value } = e.target;
    setNominees((prev) => {
      let arr = [...prev];

      arr.forEach((item, index) => {
        if (index === _index) {
          item[name] = value;
        }
      });

      if (name === "ppo_number") {
        if (value && value.length !== 12) {
          setNomineeError({
            ...nomineeError,
            [`ppo_number_${_index}`]: {
              message: "PPO number must be 12 digits.",
              index: _index,
            },
          });
        } else {
          setNomineeError({
            ...nomineeError,
            [`ppo_number_${_index}`]: "",
          });
        }
      }

      if (name === "name_of_establishment") {
        if ((value && value.trim().length < 3) || value.trim().length > 100) {
          setNomineeError({
            ...nomineeError,
            [`name_of_establishment_${_index}`]: {
              message: "This field must be more than 3 and less tha 100 char.",
              index: _index,
            },
          });
        } else {
          setNomineeError({
            ...nomineeError,
            [`name_of_establishment_${_index}`]: "",
          });
        }
      }

      if (name === "date_of_joining") {
        if (value && new Date() < new Date(value)) {
          setNomineeError({
            ...nomineeError,
            [`date_of_joining_${_index}`]: {
              message: "Future date is not allowed.",
              index: _index,
            },
          });
        } else {
          if (
            nominees[_index]?.date_of_exit &&
            new Date(value) > new Date(nominees[_index]?.date_of_exit)
          ) {
            setNomineeError({
              ...nomineeError,
              [`date_of_joining_${_index}`]: {
                message: "Date of joining must be less than Date of exit.",
                index: _index,
              },
            });
          } else {
            setNomineeError({
              ...nomineeError,
              [`date_of_joining_${_index}`]: "",
            });
          }
        }
      }

      if (name === "date_of_exit") {
        if (
          nominees[_index]?.date_of_joining &&
          new Date(value) < new Date(nominees[_index]?.date_of_joining)
        ) {
          setNomineeError({
            ...nomineeError,
            [`date_of_exit_${_index}`]: {
              message: "Date of exit must be greater than Date of joining.",
              index: _index,
            },
          });
        } else {
          setNomineeError({
            ...nomineeError,
            [`date_of_exit_${_index}`]: "",
          });
        }
      }

      if (name === "universal_account_number") {
        if (value && value?.length !== 12) {
          setNomineeError({
            ...nomineeError,
            [`universal_account_number_${_index}`]: {
              message: "Universal Account number must be 12 digit.",
              index: _index,
            },
          });
        } else {
          setNomineeError({
            ...nomineeError,
            [`universal_account_number_${_index}`]: "",
          });
        }
      }

      if (name === "pf_account_number") {
        if (value && (value.length > 22 || value.length < 10)) {
          setNomineeError({
            ...nomineeError,
            [`pf_account_number_${_index}`]: {
              message:
                "PF Account number must be greater than 10 or less than 22 char.",
              index: _index,
            },
          });
        } else {
          setNomineeError({
            ...nomineeError,
            [`pf_account_number_${_index}`]: "",
          });
        }
      }

      return [...arr];
    });
  };

  const handleChangePensionNominee = (e, _index) => {
    const { name, value } = e.target;
    setPensionnominees((prev) => {
      let arr = [...prev];

      arr.forEach((item, index) => {
        if (index === _index) {
          item[name] = value;
        }
      });

      if (name === "name_and_address_of_trust") {
        if ((value && value.trim().length < 3) || value.trim().length > 100) {
          setPensionnomineeError({
            ...pensionnomineeError,
            [`name_and_address_of_trust_${_index}`]: {
              message: "This field must be more than 3 and less tha 100 char.",
              index: _index,
            },
          });
        } else {
          setPensionnomineeError({
            ...pensionnomineeError,
            [`name_and_address_of_trust_${_index}`]: "",
          });
        }
      }

      if (name === "date_of_joining") {
        if (value && new Date() < new Date(value)) {
          setPensionnomineeError({
            ...pensionnomineeError,
            [`date_of_joining_${_index}`]: {
              message: "Future date is not allowed.",
              index: _index,
            },
          });
        } else {
          if (
            pensionnominees[_index]?.date_of_exit &&
            new Date(value) > new Date(pensionnominees[_index]?.date_of_exit)
          ) {
            setPensionnomineeError({
              ...pensionnomineeError,
              [`date_of_joining_${_index}`]: {
                message: "Date of joining must be less than Date of exit.",
                index: _index,
              },
            });
          } else {
            setPensionnomineeError({
              ...pensionnomineeError,
              [`date_of_joining_${_index}`]: "",
            });
          }
        }
      }

      if (name === "date_of_exit") {
        if (
          pensionnominees[_index]?.date_of_joining &&
          new Date(value) < new Date(pensionnominees[_index]?.date_of_joining)
        ) {
          setPensionnomineeError({
            ...pensionnomineeError,
            [`date_of_exit_${_index}`]: {
              message: "Date of exit must be greater than Date of joining.",
              index: _index,
            },
          });
        } else {
          setPensionnomineeError({
            ...pensionnomineeError,
            [`date_of_exit_${_index}`]: "",
          });
        }
      }

      if (name === "universal_account_number") {
        if (value && value?.length !== 12) {
          setPensionnomineeError({
            ...pensionnomineeError,
            [`universal_account_number_${_index}`]: {
              message: "Universal Account number must be 12 digit.",
              index: _index,
            },
          });
        } else {
          setPensionnomineeError({
            ...pensionnomineeError,
            [`universal_account_number_${_index}`]: "",
          });
        }
      }

      return [...arr];
    });
  };

  const validateInput = (e) => {
    if (isFormDataEmpty()) {
      return true;
    }

    if (fatherOrSpouse) {
      if (father === "") {
        return true;
      }
    } else {
      if (spouse === "") {
        return true;
      }
    }

    return false;
  };

  const checkNomineeError = () => {
    for (let key in nomineeError) {
      if (nomineeError[key] !== "") {
        return true;
      }
    }
    return false;
  };

  const checkPensionNomineeError = () => {
    for (let key in pensionnomineeError) {
      if (pensionnomineeError[key] !== "") {
        return true;
      }
    }
    return false;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let flag = false;
    for (let key in error) {
      if (error[key] !== "") {
        flag = true;
        break;
      }
    }

    if (
      flag ||
      ((formData?.provident_fund_scheme === "yes" ||
        formData?.pension_scheme === "yes") &&
        (checkNomineeError() || checkPensionNomineeError()))
    ) {
      swal({
        title: "Error",
        // text: "Are you sure you want to Approve? Before on-boarding the candidate, please cross verify the TRF.",
        icon: "error",
        content: {
          element: "div",
          attributes: {
            innerHTML: `
                  <p style="text-align:center">Before submit please resolve all the errors.</p>       
                `,
          },
        },
        buttons: {
          cancel: false,
          confirm: true,
        },
      }).then((flag) => {});
      return;
    }

    const data = {
      companyDocumentId: form?._id,
      candidateId: id,
      documentDetails: {
        ...formData,
        fatherOrSpouse,
        ...(formData?.provident_fund_scheme === "yes" ||
        formData?.pension_scheme === "yes"
          ? { unexempted }
          : { unexempted: "no" }),
        ...(formData?.provident_fund_scheme === "yes" ||
        formData?.pension_scheme === "yes"
          ? { exempted }
          : { exempted: "no" }),
        ...(fatherOrSpouse ? { father_name: father } : { spouse_name: spouse }),
        ...(accountNumber !== "" ? { accountNumber } : {}),
        ...(ifcCode ? { ifcCode } : {}),
        ...(formData?.provident_fund_scheme === "yes" ||
        formData?.pension_scheme === "yes"
          ? {
              ...(unexempted === "yes"
                ? { nominees: [...nominees.filter((nom) => nom !== null)] }
                : {
                    nominees: [
                      {
                        name_of_establishment: "",
                        ppo_number: "",
                        ncp_days: "",
                        date_of_joining: "",
                        date_of_exit: "",
                        universal_account_number: "",
                        pf_account_number: "",
                        scheme_certificate: "",
                      },
                    ],
                  }),
              ...(exempted === "yes"
                ? {
                    pensionnominees: [
                      ...pensionnominees.filter((nom) => nom !== null),
                    ],
                  }
                : {
                    pensionnominees: [
                      {
                        name_and_address_of_trust: "",
                        ncp_days: "",
                        date_of_joining: "",
                        date_of_exit: "",
                        universal_account_number: "",
                        eps_account_number: "",
                        scheme_certificate: "",
                      },
                    ],
                  }),
            }
          : {
              nominees: [
                {
                  name_of_establishment: "",
                  ppo_number: "",
                  ncp_days: "",
                  date_of_joining: "",
                  date_of_exit: "",
                  universal_account_number: "",
                  pf_account_number: "",
                  scheme_certificate: "",
                },
              ],
              pensionnominees: [
                {
                  name_and_address_of_trust: "",
                  ncp_days: "",
                  date_of_joining: "",
                  date_of_exit: "",
                  universal_account_number: "",
                  eps_account_number: "",
                  scheme_certificate: "",
                },
              ],
            }),
      },
      formStatus: true,
    };

    try {
      setLoading(true);
      await api.post(`/companyDocuments/DocumentMaping`, data, {
        tokenType: "candidate",
      });
      await getAllJoiningFilledForms();
      message.success("Your form has been submitted successfully!");
      setActivePanel(null);
      setLoading(false);
      setIsFieldTouch(false);
    } catch (err) {
      setLoading(false);
    }
  };

  useEffect(() => {
    setForm11PreviewData({
      exempted,
      unexempted,
      ...formData,
      fatherOrSpouse,
      ...(fatherOrSpouse ? { father_name: father } : { spouse_name: spouse }),
      ...(accountNumber !== "" ? { accountNumber } : {}),
      ...(ifcCode ? { ifcCode } : {}),
      ...(formData?.provident_fund_scheme === "yes" ||
      formData?.pension_scheme === "yes"
        ? {
            ...(unexempted === "yes" ? { nominees } : {}),
            ...(exempted === "yes" ? { pensionnominees } : {}),
          }
        : {}),
    });

    let e = {};

    // if (formData?.name.trim()) {
    //   e.name = isNameValid(formData.name);
    // }

    // if (father.trim()) {
    //   e.father_name = isNameValid(father);
    // }

    // if (spouse.trim()) {
    //   e.spouse_name = isNameValid(spouse);
    // }

    // if (formData?.mobile_number.trim()) {
    //   e.mobile_number = isPhoneValid(formData?.mobile_number);
    // }

    // if (formData?.aadhar_number.trim()) {
    //   e.aadhar_number = isAadharValid(formData?.aadhar_number);
    // }

    // if (formData?.email.trim()) {
    //   e.email = isEmailValid(formData?.email);
    // }

    // if (new Date(formData.dob) > new Date()) {
    //   e.dob = "Future date is not allowed.";
    // } else {
    //   e.dob = "";
    // }

    // if (formData?.place && formData?.place?.trim().length < 3) {
    //   e.place = "Place must be more than 3 char.";
    // } else {
    //   e.place = "";
    // }

    // if (ifcCode && ifcCode?.trim().length !== 11) {
    //   e.ifc_code = "IFC Code must be 11 digit.";
    // } else {
    //   e.ifc_code = "";
    // }
    // if (accountNumber && accountNumber?.trim().length < 10 || accountNumber && accountNumber?.trim().length > 17) {
    //   e.banck_aac_number = "Account number must be 16 digit.";
    // } else {
    //   e.banck_aac_number = "";
    // }

    // if (formData?.pan_number && formData?.pan_number?.trim().length !== 10) {
    //   e.pan_number = "Pan number must be 10 char.";
    // } else {
    //   e.pan_number = "";
    // }

    setError(e);
  }, [formData, father, spouse, accountNumber, ifcCode, fatherOrSpouse]);

  return (
    <Card>
      {loading ? (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      ) : (
        <div className="row">
          <div className="col-12">
            <p style={{ color: "red", fontSize: "14px" }}>
              <strong>Note:</strong> All fields marked with an asterisk (
              <span style={{ color: "red" }}>*</span>) are mandatory.
            </p>
          </div>
          <div className="col-12">
            <div className="row">
              <div className="form-group col-md-4 form-builder-element mb-3">
                <label htmlFor="">
                  Name of The Member
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  className="form-control form-view"
                  type="text"
                  placeholder=""
                  disabled={filledForm?.formStatusByHR || true}
                  name="name"
                  onChange={handleChange}
                  style={{
                    ...(error?.name ? { border: "1px solid red" } : {}),
                  }}
                  value={formData?.name.replaceAll(/\b[a-z]/g, (p) =>
                    p.toUpperCase()
                  )}
                />
                {error?.name && (
                  <p style={{ color: "red", fontSize: "10px" }}>
                    {error?.name}
                  </p>
                )}
              </div>

              <div className="form-group mb-3 col-md-4 form-builder-element">
                <label htmlFor="">
                  Choose Father or Spouse
                  <span style={{ color: "red" }}>*</span>
                </label>
                <div className="row">
                  <div className="custom-control custom-radio mx-3">
                    <input
                      id="father"
                      disabled={filledForm?.formStatusByHR}
                      name="fatherOrSpouse"
                      type="checkbox"
                      className="custom-control-input form-view"
                      onChange={() => setFatherOrSpouse(true)}
                      value="father"
                      checked={fatherOrSpouse}
                    />
                    <label htmlFor="father" className="custom-control-label">
                      Father
                    </label>
                  </div>
                  <div className="custom-control custom-radio mx-3">
                    <input
                      disabled={filledForm?.formStatusByHR}
                      id="spouse"
                      name="fatherOrSpouse"
                      type="checkbox"
                      className="custom-control-input form-view"
                      onChange={() => setFatherOrSpouse(false)}
                      value="spouse"
                      checked={!fatherOrSpouse}
                    />
                    <label htmlFor="spouse" className="custom-control-label">
                      Spouse
                    </label>
                  </div>
                </div>
              </div>

              {fatherOrSpouse ? (
                <div className="form-group col-md-4 form-builder-element mb-3">
                  <label htmlFor="">
                    Father's Name
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    className="form-control form-view"
                    type="text"
                    placeholder=""
                    name="father_name"
                    disabled={filledForm?.formStatusByHR || true}
                    onChange={(e) => setFather(e.target.value)}
                    style={{
                      ...(error?.father_name
                        ? { border: "1px solid red" }
                        : {}),
                    }}
                    value={father.replaceAll(/\b[a-z]/g, (p) =>
                      p.toUpperCase()
                    )}
                  />
                  {error?.father_name && (
                    <p style={{ color: "red", fontSize: "10px" }}>
                      {error?.father_name}
                    </p>
                  )}
                </div>
              ) : (
                <div className="form-group col-md-4 form-builder-element mb-3">
                  <label htmlFor="">
                    Spouse's Name
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    className="form-control form-view"
                    type="text"
                    placeholder=""
                    name="spouse_name"
                    disabled={filledForm?.formStatusByHR || true}
                    onChange={(e) => setSpouse(e.target.value)}
                    style={{
                      ...(error?.spouse_name
                        ? { border: "1px solid red" }
                        : {}),
                    }}
                    value={spouse}
                  />
                  {error?.spouse_name && (
                    <p style={{ color: "red", fontSize: "10px" }}>
                      {error?.spouse_name}
                    </p>
                  )}
                </div>
              )}
              <div className="form-group col-md-4 form-builder-element mb-3">
                <label htmlFor="">
                  Email
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  className="form-control form-view"
                  type="text"
                  placeholder=""
                  name="email"
                  disabled={filledForm?.formStatusByHR || true}
                  onChange={handleChange}
                  style={{
                    ...(error?.email ? { border: "1px solid red" } : {}),
                  }}
                  value={formData?.email}
                />
                {error?.email && (
                  <p style={{ color: "red", fontSize: "10px" }}>
                    {error?.email}
                  </p>
                )}
              </div>
              <div className="form-group col-md-4 form-builder-element mb-3">
                <label htmlFor="">
                  Mobile No.
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  className="form-control form-view"
                  type="number"
                  placeholder=""
                  name="mobile_number"
                  disabled={filledForm?.formStatusByHR || true}
                  min={0}
                  onChange={handleChange}
                  style={{
                    ...(error?.mobile_number
                      ? { border: "1px solid red" }
                      : {}),
                  }}
                  value={formData?.mobile_number}
                />
                {error?.mobile_number && (
                  <p style={{ color: "red", fontSize: "10px" }}>
                    {error?.mobile_number}
                  </p>
                )}
              </div>
              <div className="form-group col-md-4 form-builder-element mb-3">
                <label htmlFor="">
                  Date of Birth
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  className="form-control form-view"
                  type="date"
                  disabled={filledForm?.formStatusByHR || true}
                  name="dob"
                  max={formatDate(new Date())}
                  onChange={handleChange}
                  style={{
                    ...(error?.dob ? { border: "1px solid red" } : {}),
                  }}
                  value={formData?.dob}
                />
                {error?.dob && (
                  <p style={{ color: "red", fontSize: "10px" }}>{error?.dob}</p>
                )}
              </div>
            </div>
            <div className="row">
              <div className="form-group mb-3 col-md-4 form-builder-element">
                <label htmlFor="">
                  Marital Status
                  <span style={{ color: "red" }}>*</span>
                </label>
                <div className="row">
                  <div className={"col-sm-3 px-1"}>
                    <div className="custom-control custom-radio mb-3">
                      <input
                        id="form11_married"
                        name="marital_status"
                        disabled={filledForm?.formStatusByHR}
                        type="checkbox"
                        className="custom-control-input form-view"
                        onChange={handleChange}
                        value="married"
                        checked={formData?.marital_status === "married"}
                      />
                      <label
                        htmlFor="form11_married"
                        className="custom-control-label"
                      >
                        Married
                      </label>
                    </div>
                  </div>
                  <div className={"col-sm-3 px-1"}>
                    <div className="custom-control custom-radio mb-3">
                      <input
                        id="form11_unmarried"
                        name="marital_status"
                        type="checkbox"
                        disabled={filledForm?.formStatusByHR}
                        className="custom-control-input form-view"
                        onChange={handleChange}
                        checked={formData?.marital_status === "unmarried"}
                        value="unmarried"
                      />
                      <label
                        htmlFor="form11_unmarried"
                        className="custom-control-label"
                      >
                        Unmarried
                      </label>
                    </div>
                  </div>
                  <div className={"col-sm-3 px-1"}>
                    <div className="custom-control custom-radio mb-3">
                      <input
                        id="form11_widow"
                        name="marital_status"
                        type="checkbox"
                        disabled={filledForm?.formStatusByHR}
                        className="custom-control-input form-view"
                        onChange={handleChange}
                        checked={formData?.marital_status === "widow"}
                        value="widow"
                      />
                      <label
                        htmlFor="form11_widow"
                        className="custom-control-label"
                      >
                        Widow
                      </label>
                    </div>
                  </div>
                  <div className={"col-sm-3 px-1"}>
                    <div className="custom-control custom-radio mb-3">
                      <input
                        id="form11_separated"
                        name="marital_status"
                        type="checkbox"
                        disabled={filledForm?.formStatusByHR}
                        className="custom-control-input form-view"
                        onChange={handleChange}
                        checked={formData?.marital_status === "separated"}
                        value="separated"
                      />
                      <label
                        htmlFor="form11_separated"
                        className="custom-control-label"
                      >
                        Separated
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-group mb-3 col-md-4 form-builder-element">
                <label htmlFor="">
                  Sex
                  <span style={{ color: "red" }}>*</span>
                </label>
                <div className="row">
                  <div className="custom-control custom-radio mx-3">
                    <input
                      id="form11_male"
                      disabled={filledForm?.formStatusByHR}
                      name="sex"
                      type="checkbox"
                      className="custom-control-input form-view"
                      onChange={handleChange}
                      value="male"
                      checked={formData?.sex === "male"}
                    />
                    <label
                      htmlFor="form11_male"
                      className="custom-control-label"
                    >
                      Male
                    </label>
                  </div>
                  <div className="custom-control custom-radio mx-3">
                    <input
                      disabled={filledForm?.formStatusByHR}
                      id="form11_female"
                      name="sex"
                      type="checkbox"
                      className="custom-control-input form-view"
                      onChange={handleChange}
                      value="female"
                      checked={formData?.sex === "female"}
                    />
                    <label
                      htmlFor="form11_female"
                      className="custom-control-label"
                    >
                      Female
                    </label>
                  </div>
                </div>
              </div>
              {/* <div className="form-group col-md-4 form-builder-element mb-3">
                <label htmlFor="">
                  Place
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  className="form-control form-view"
                  type="text"
                  placeholder=""
                  name="place"
                  disabled={filledForm?.formStatusByHR}
                  onChange={handleChange}
                  style={{
                    ...(error?.place ? { border: "1px solid red" } : {})
                  }}
                  value={formData?.place}
                />
                {error?.place && (
                  <p style={{ color: "red", fontSize: "10px" }}>
                    {error?.place}
                  </p>
                )}
              </div> */}
            </div>
            <div className="row">
              <div className="form-group col-md-4 form-builder-element mb-3">
                <label htmlFor="">
                  Aadhar Card No.
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  className="form-control form-view"
                  type="number"
                  min={0}
                  placeholder=""
                  name="aadhar_number"
                  disabled={filledForm?.formStatusByHR || true}
                  onChange={handleChange}
                  style={{
                    ...(error?.aadhar_number
                      ? { border: "1px solid red" }
                      : {}),
                  }}
                  value={formData?.aadhar_number}
                />
                {error?.aadhar_number && (
                  <p style={{ color: "red", fontSize: "10px" }}>
                    {error?.aadhar_number}
                  </p>
                )}
              </div>
              <div className="form-group col-md-4 form-builder-element mb-3">
                <label htmlFor="">Pan Card No.</label>
                <input
                  className="form-control form-view"
                  type="text"
                  placeholder=""
                  name="pan_number"
                  disabled={filledForm?.formStatusByHR || true}
                  onChange={handleChange}
                  style={{
                    ...(error?.pan_number ? { border: "1px solid red" } : {}),
                  }}
                  value={formData?.pan_number}
                />
                {error?.pan_number && (
                  <p style={{ color: "red", fontSize: "10px" }}>
                    {error?.pan_number}
                  </p>
                )}
              </div>
              <div className="form-group col-md-4 form-builder-element mb-3">
                <label htmlFor="">Bank Account Number</label>
                <input
                  className="form-control form-view"
                  type="number"
                  placeholder=""
                  name="banck_aac_number"
                  disabled={filledForm?.formStatusByHR || true}
                  onChange={(e) => setAccountNumber(e.target.value)}
                  style={{
                    ...(error?.banck_aac_number
                      ? { border: "1px solid red" }
                      : {}),
                  }}
                  value={accountNumber}
                />
                {error?.banck_aac_number && (
                  <p style={{ color: "red", fontSize: "10px" }}>
                    {error?.banck_aac_number}
                  </p>
                )}
              </div>
              <div className="form-group col-md-4 form-builder-element mb-3">
                <label htmlFor="">IFS Code Of The Branch</label>
                <input
                  className="form-control form-view"
                  type="text"
                  placeholder=""
                  name="ifc_code"
                  disabled={filledForm?.formStatusByHR || true}
                  onChange={(e) => setIfcCode(e.target.value)}
                  style={{
                    ...(error?.ifc_code ? { border: "1px solid red" } : {}),
                  }}
                  value={ifcCode}
                />
                {error?.ifc_code && (
                  <p style={{ color: "red", fontSize: "10px" }}>
                    {error?.ifc_code}
                  </p>
                )}
              </div>
              <div className="form-group mb-3 col-md-4 form-builder-element">
                <label htmlFor="">
                  Whether earlier a member of Employees' Provident Fund Scheme
                  1952
                  <span style={{ color: "red" }}>*</span>
                </label>
                <div className="row">
                  <div className="custom-control custom-radio mx-3">
                    <input
                      id="provident_fund_scheme_yes"
                      disabled={filledForm?.formStatusByHR}
                      type="checkbox"
                      name="provident_fund_scheme"
                      className="custom-control-input form-view"
                      onChange={handleChange}
                      value="yes"
                      checked={formData?.provident_fund_scheme === "yes"}
                    />
                    <label
                      htmlFor="provident_fund_scheme_yes"
                      className="custom-control-label"
                    >
                      Yes
                    </label>
                  </div>
                  <div className="custom-control custom-radio mx-3">
                    <input
                      disabled={filledForm?.formStatusByHR}
                      id="provident_fund_scheme_no"
                      name="provident_fund_scheme"
                      type="checkbox"
                      className="custom-control-input form-view"
                      onChange={handleChange}
                      value="no"
                      checked={formData?.provident_fund_scheme === "no"}
                    />
                    <label
                      htmlFor="provident_fund_scheme_no"
                      className="custom-control-label"
                    >
                      No
                    </label>
                  </div>
                </div>
              </div>
              <div className="form-group mb-3 col-md-4 form-builder-element">
                <label htmlFor="">
                  Whether withdrawn accumulations in the Provident Fund
                </label>
                <div className="row">
                  <div className="custom-control custom-radio mx-3">
                    <input
                      id="withdrawn_accumulations_yes"
                      disabled={
                        filledForm?.formStatusByHR ||
                        formData?.provident_fund_scheme === "no"
                      }
                      type="checkbox"
                      name="withdrawn_accumulations"
                      className="custom-control-input form-view"
                      onChange={handleChange}
                      value="yes"
                      checked={formData?.withdrawn_accumulations === "yes"}
                    />
                    <label
                      htmlFor="withdrawn_accumulations_yes"
                      className="custom-control-label"
                    >
                      Yes
                    </label>
                  </div>
                  <div className="custom-control custom-radio mx-3">
                    <input
                      disabled={
                        filledForm?.formStatusByHR ||
                        formData?.provident_fund_scheme === "no"
                      }
                      id="withdrawn_accumulations_no"
                      name="withdrawn_accumulations"
                      type="checkbox"
                      className="custom-control-input form-view"
                      onChange={handleChange}
                      value="no"
                      checked={formData?.withdrawn_accumulations === "no"}
                    />
                    <label
                      htmlFor="withdrawn_accumulations_no"
                      className="custom-control-label"
                    >
                      No
                    </label>
                  </div>
                </div>
              </div>

              <div className="form-group mb-3 col-md-4 form-builder-element">
                <label htmlFor="">
                  Whether earlier a member of Employees' Pension Scheme, 1995
                  <span style={{ color: "red" }}>*</span>
                </label>
                <div className="row">
                  <div className="custom-control custom-radio mx-3">
                    <input
                      id="pension_scheme_yes"
                      disabled={filledForm?.formStatusByHR}
                      type="checkbox"
                      name="pension_scheme"
                      className="custom-control-input form-view"
                      onChange={handleChange}
                      value="yes"
                      checked={formData?.pension_scheme === "yes"}
                    />
                    <label
                      htmlFor="pension_scheme_yes"
                      className="custom-control-label"
                    >
                      Yes
                    </label>
                  </div>
                  <div className="custom-control custom-radio mx-3">
                    <input
                      disabled={filledForm?.formStatusByHR}
                      id="pension_scheme_no"
                      name="pension_scheme"
                      type="checkbox"
                      className="custom-control-input form-view"
                      onChange={handleChange}
                      value="no"
                      checked={formData?.pension_scheme === "no"}
                    />
                    <label
                      htmlFor="pension_scheme_no"
                      className="custom-control-label"
                    >
                      No
                    </label>
                  </div>
                </div>
              </div>
            </div>
            {(formData?.provident_fund_scheme === "yes" ||
              formData?.pension_scheme === "yes") && (
              <>
                <div className="row" style={{ position: "relative" }}>
                  <div
                    style={{
                      position: "absolute",
                      top: "25px",
                      zIndex: "9",
                      right: "5px",
                    }}
                  >
                    <input
                      disabled={filledForm?.formStatusByHR}
                      id="unexempted"
                      name="unexempted"
                      type="checkbox"
                      style={{ transform: "scale(1.5)" }}
                      onChange={(e) =>
                        setUnexempted(e.target.checked ? "yes" : "no")
                      }
                      checked={unexempted === "yes"}
                    />
                  </div>
                  <div>
                    {nominees.map((nominee, index) => {
                      if (nominee) {
                        row = row + 1;
                        return (
                          <Card
                            key={index}
                            title={
                              <div className="d-flex justify-content-between">
                                <span>{`Previous employment details: - Un-exempted ${row}`}</span>
                                <div>
                                  {[...nominees.filter((nom) => nom !== null)]
                                    .length !== 1 && (
                                    <div className="col-1 ">
                                      <button
                                        className={`btn ${"btn-danger"} ml-4`}
                                        onClick={() => deleteNominee(index)}
                                      >
                                        <span className="pr-2">
                                          <i
                                            className="fa fa-trash"
                                            aria-hidden="true"
                                          ></i>
                                        </span>
                                        Delete
                                      </button>
                                    </div>
                                  )}
                                </div>
                              </div>
                            }
                          >
                            <div className="col-12">
                              <div className="row">
                                <div className="form-group col-md-4 form-builder-element mb-3">
                                  <label htmlFor="">
                                    Establishment Name and Address
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <input
                                    className="form-control form-view"
                                    type="text"
                                    placeholder=""
                                    name="name_of_establishment"
                                    disabled={filledForm?.formStatusByHR}
                                    onChange={(e) =>
                                      handleChangeNominee(e, index)
                                    }
                                    style={{
                                      ...(nomineeError[
                                        `name_of_establishment_${index}`
                                      ]?.index === index
                                        ? { border: "1px solid red" }
                                        : {}),
                                    }}
                                    value={nominee?.name_of_establishment}
                                  />
                                  {nomineeError[
                                    `name_of_establishment_${index}`
                                  ]?.index === index && (
                                    <p
                                      style={{
                                        color: "red",
                                        fontSize: "10px",
                                      }}
                                    >
                                      {
                                        nomineeError[
                                          `name_of_establishment_${index}`
                                        ]?.message
                                      }
                                    </p>
                                  )}
                                </div>
                                <div className="form-group col-md-4 form-builder-element mb-3">
                                  <label htmlFor="">
                                    Universal Account Number
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <input
                                    className="form-control form-view"
                                    type="number"
                                    placeholder=""
                                    name="universal_account_number"
                                    disabled={filledForm?.formStatusByHR}
                                    onChange={(e) =>
                                      handleChangeNominee(e, index)
                                    }
                                    style={{
                                      ...(nomineeError[
                                        `universal_account_number_${index}`
                                      ]?.index === index
                                        ? { border: "1px solid red" }
                                        : {}),
                                    }}
                                    value={nominee?.universal_account_number}
                                  />
                                  {nomineeError[
                                    `universal_account_number_${index}`
                                  ]?.index === index && (
                                    <p
                                      style={{
                                        color: "red",
                                        fontSize: "10px",
                                      }}
                                    >
                                      {
                                        nomineeError[
                                          `universal_account_number_${index}`
                                        ]?.message
                                      }
                                    </p>
                                  )}
                                </div>
                                <div className="form-group col-md-4 form-builder-element mb-3">
                                  <label htmlFor="">
                                    PF Account Number
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <input
                                    className="form-control form-view"
                                    type="text"
                                    placeholder=""
                                    name="pf_account_number"
                                    disabled={filledForm?.formStatusByHR}
                                    onChange={(e) =>
                                      handleChangeNominee(e, index)
                                    }
                                    style={{
                                      ...(nomineeError[
                                        `pf_account_number_${index}`
                                      ]?.index === index
                                        ? { border: "1px solid red" }
                                        : {}),
                                    }}
                                    value={nominee?.pf_account_number}
                                  />
                                  {nomineeError[`pf_account_number_${index}`]
                                    ?.index === index && (
                                    <p
                                      style={{
                                        color: "red",
                                        fontSize: "10px",
                                      }}
                                    >
                                      {
                                        nomineeError[
                                          `pf_account_number_${index}`
                                        ]?.message
                                      }
                                    </p>
                                  )}
                                </div>
                                <div className="form-group col-md-4 form-builder-element mb-3">
                                  <label htmlFor="">
                                    Date of Joining
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <input
                                    className="form-control form-view"
                                    type="date"
                                    disabled={filledForm?.formStatusByHR}
                                    name="date_of_joining"
                                    max={formatDate(new Date())}
                                    onChange={(e) =>
                                      handleChangeNominee(e, index)
                                    }
                                    style={{
                                      ...(nomineeError[
                                        `date_of_joining_${index}`
                                      ]?.index === index
                                        ? { border: "1px solid red" }
                                        : {}),
                                    }}
                                    value={nominee?.date_of_joining}
                                  />
                                  {nomineeError[`date_of_joining_${index}`]
                                    ?.index === index && (
                                    <p
                                      style={{
                                        color: "red",
                                        fontSize: "10px",
                                      }}
                                    >
                                      {
                                        nomineeError[`date_of_joining_${index}`]
                                          ?.message
                                      }
                                    </p>
                                  )}
                                </div>
                                <div className="form-group col-md-4 form-builder-element mb-3">
                                  <label htmlFor="">
                                    Date of Exit
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <input
                                    className="form-control form-view"
                                    type="date"
                                    disabled={filledForm?.formStatusByHR}
                                    name="date_of_exit"
                                    max={formatDate(new Date())}
                                    onChange={(e) =>
                                      handleChangeNominee(e, index)
                                    }
                                    style={{
                                      ...(nomineeError[`date_of_exit_${index}`]
                                        ?.index === index
                                        ? { border: "1px solid red" }
                                        : {}),
                                    }}
                                    value={nominee?.date_of_exit}
                                  />
                                  {nomineeError[`date_of_exit_${index}`]
                                    ?.index === index && (
                                    <p
                                      style={{
                                        color: "red",
                                        fontSize: "10px",
                                      }}
                                    >
                                      {
                                        nomineeError[`date_of_exit_${index}`]
                                          ?.message
                                      }
                                    </p>
                                  )}
                                </div>

                                <div className="form-group col-md-4 form-builder-element mb-3">
                                  <label htmlFor="">
                                    Scheme Certificate (if issued)
                                  </label>
                                  <input
                                    className="form-control form-view"
                                    type="text"
                                    disabled={filledForm?.formStatusByHR}
                                    name="scheme_certificate"
                                    onChange={(e) =>
                                      handleChangeNominee(e, index)
                                    }
                                    style={{
                                      ...(error?.nominee_guardian_name_address
                                        ? { border: "1px solid red" }
                                        : {}),
                                    }}
                                    value={nominee?.scheme_certificate}
                                  />
                                </div>
                                <div className="form-group col-md-4 form-builder-element mb-3">
                                  <label htmlFor="">
                                    PPO number (if issued)
                                  </label>
                                  <input
                                    className="form-control form-view"
                                    type="number"
                                    disabled={filledForm?.formStatusByHR}
                                    name="ppo_number"
                                    onChange={(e) =>
                                      handleChangeNominee(e, index)
                                    }
                                    style={{
                                      ...(nomineeError[`ppo_number_${index}`]
                                        ?.index === index
                                        ? { border: "1px solid red" }
                                        : {}),
                                    }}
                                    value={nominee?.ppo_number}
                                  />
                                  {nomineeError[`ppo_number_${index}`]
                                    ?.index === index && (
                                    <p
                                      style={{
                                        color: "red",
                                        fontSize: "10px",
                                      }}
                                    >
                                      {
                                        nomineeError[`ppo_number_${index}`]
                                          ?.message
                                      }
                                    </p>
                                  )}
                                </div>
                                <div className="form-group col-md-4 form-builder-element mb-3">
                                  <label htmlFor="">
                                    Non Contributory Period (NCP) Days
                                  </label>
                                  <input
                                    className="form-control form-view"
                                    type="number"
                                    disabled={filledForm?.formStatusByHR}
                                    name="ncp_days"
                                    onChange={(e) =>
                                      handleChangeNominee(e, index)
                                    }
                                    style={{
                                      ...(error?.ncp_days
                                        ? { border: "1px solid red" }
                                        : {}),
                                    }}
                                    value={nominee?.ncp_days}
                                  />
                                </div>

                                {[...nominees.filter((nom) => nom !== null)]
                                  .length < 5 &&
                                  row ===
                                    [...nominees.filter((nom) => nom !== null)]
                                      .length && (
                                    <div className="col-md-4 d-flex justify-content-end align-items-center">
                                      <button
                                        className={`btn ${"btn-primary"} ml-4`}
                                        onClick={addMore}
                                      >
                                        <span className="pr-2">
                                          <i
                                            className="fa fa-plus"
                                            aria-hidden="true"
                                          ></i>
                                        </span>
                                        Add More
                                      </button>
                                    </div>
                                  )}
                              </div>
                            </div>
                          </Card>
                        );
                      }
                    })}
                  </div>
                </div>
              </>
            )}
            {(formData?.provident_fund_scheme === "yes" ||
              formData?.pension_scheme === "yes") && (
              <>
                <div className="row" style={{ position: "relative" }}>
                  <div
                    style={{
                      position: "absolute",
                      top: "25px",
                      zIndex: "9",
                      right: "5px",
                    }}
                  >
                    <input
                      disabled={filledForm?.formStatusByHR}
                      id="exempted"
                      name="exempted"
                      type="checkbox"
                      style={{ transform: "scale(1.5)" }}
                      onChange={(e) =>
                        setExempted(e.target.checked ? "yes" : "no")
                      }
                      checked={exempted === "yes"}
                    />
                  </div>
                  <div>
                    {pensionnominees.map((nomineepen, index) => {
                      if (nomineepen) {
                        another_row = another_row + 1;
                        return (
                          <Card
                            key={index}
                            title={
                              <div className="d-flex justify-content-between">
                                <span>{`Previous employment details: - For Exempted Trusts ${another_row}`}</span>
                                <div>
                                  {[
                                    ...pensionnominees.filter(
                                      (nom) => nom !== null
                                    ),
                                  ].length !== 1 && (
                                    <div className="col-1 ">
                                      <button
                                        className={`btn ${"btn-danger"} ml-4`}
                                        onClick={() =>
                                          deletePensionNominee(index)
                                        }
                                      >
                                        <span className="pr-2">
                                          <i
                                            className="fa fa-trash"
                                            aria-hidden="true"
                                          ></i>
                                        </span>
                                        Delete
                                      </button>
                                    </div>
                                  )}
                                </div>
                              </div>
                            }
                          >
                            <div className="col-12">
                              <div className="row">
                                <div className="form-group col-md-4 form-builder-element mb-3">
                                  <label htmlFor="">
                                    Name & Address of the Trust
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <input
                                    className="form-control form-view"
                                    type="text"
                                    placeholder=""
                                    name="name_and_address_of_trust"
                                    disabled={filledForm?.formStatusByHR}
                                    onChange={(e) =>
                                      handleChangePensionNominee(e, index)
                                    }
                                    style={{
                                      ...(pensionnomineeError[
                                        `name_and_address_of_trust_${index}`
                                      ]?.index === index
                                        ? { border: "1px solid red" }
                                        : {}),
                                    }}
                                    value={
                                      nomineepen?.name_and_address_of_trust
                                    }
                                  />
                                  {pensionnomineeError[
                                    `name_and_address_of_trust_${index}`
                                  ]?.index === index && (
                                    <p
                                      style={{
                                        color: "red",
                                        fontSize: "10px",
                                      }}
                                    >
                                      {
                                        pensionnomineeError[
                                          `name_and_address_of_trust_${index}`
                                        ]?.message
                                      }
                                    </p>
                                  )}
                                </div>
                                <div className="form-group col-md-4 form-builder-element mb-3">
                                  <label htmlFor="">
                                    UAN
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <input
                                    className="form-control form-view"
                                    type="number"
                                    placeholder=""
                                    name="universal_account_number"
                                    disabled={filledForm?.formStatusByHR}
                                    onChange={(e) =>
                                      handleChangePensionNominee(e, index)
                                    }
                                    style={{
                                      ...(pensionnomineeError[
                                        `universal_account_number_${index}`
                                      ]?.index === index
                                        ? { border: "1px solid red" }
                                        : {}),
                                    }}
                                    value={nomineepen?.universal_account_number}
                                  />
                                  {pensionnomineeError[
                                    `universal_account_number_${index}`
                                  ]?.index === index && (
                                    <p
                                      style={{
                                        color: "red",
                                        fontSize: "10px",
                                      }}
                                    >
                                      {
                                        pensionnomineeError[
                                          `universal_account_number_${index}`
                                        ]?.message
                                      }
                                    </p>
                                  )}
                                </div>
                                <div className="form-group col-md-4 form-builder-element mb-3">
                                  <label htmlFor="">
                                    Member EPSA/c Number
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <input
                                    className="form-control form-view"
                                    type="number"
                                    placeholder=""
                                    name="eps_account_number"
                                    disabled={filledForm?.formStatusByHR}
                                    onChange={(e) =>
                                      handleChangePensionNominee(e, index)
                                    }
                                    style={{
                                      ...(pensionnomineeError[
                                        `eps_account_number_${index}`
                                      ]?.index === index
                                        ? { border: "1px solid red" }
                                        : {}),
                                    }}
                                    value={nomineepen?.eps_account_number}
                                  />
                                  {pensionnomineeError[
                                    `eps_account_number_${index}`
                                  ]?.index === index && (
                                    <p
                                      style={{
                                        color: "red",
                                        fontSize: "10px",
                                      }}
                                    >
                                      {
                                        pensionnomineeError[
                                          `eps_account_number_${index}`
                                        ]?.message
                                      }
                                    </p>
                                  )}
                                </div>
                                <div className="form-group col-md-4 form-builder-element mb-3">
                                  <label htmlFor="">
                                    Date of Joining
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <input
                                    className="form-control form-view"
                                    type="date"
                                    disabled={filledForm?.formStatusByHR}
                                    name="date_of_joining"
                                    max={formatDate(new Date())}
                                    onChange={(e) =>
                                      handleChangePensionNominee(e, index)
                                    }
                                    style={{
                                      ...(pensionnomineeError[
                                        `date_of_joining_${index}`
                                      ]?.index === index
                                        ? { border: "1px solid red" }
                                        : {}),
                                    }}
                                    value={nomineepen?.date_of_joining}
                                  />
                                  {pensionnomineeError[
                                    `date_of_joining_${index}`
                                  ]?.index === index && (
                                    <p
                                      style={{
                                        color: "red",
                                        fontSize: "10px",
                                      }}
                                    >
                                      {
                                        pensionnomineeError[
                                          `date_of_joining_${index}`
                                        ]?.message
                                      }
                                    </p>
                                  )}
                                </div>
                                <div className="form-group col-md-4 form-builder-element mb-3">
                                  <label htmlFor="">
                                    Date of Exit
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <input
                                    className="form-control form-view"
                                    type="date"
                                    disabled={filledForm?.formStatusByHR}
                                    name="date_of_exit"
                                    max={formatDate(new Date())}
                                    onChange={(e) =>
                                      handleChangePensionNominee(e, index)
                                    }
                                    style={{
                                      ...(pensionnomineeError[
                                        `date_of_exit_${index}`
                                      ]?.index === index
                                        ? { border: "1px solid red" }
                                        : {}),
                                    }}
                                    value={nomineepen?.date_of_exit}
                                  />
                                  {pensionnomineeError[`date_of_exit_${index}`]
                                    ?.index === index && (
                                    <p
                                      style={{
                                        color: "red",
                                        fontSize: "10px",
                                      }}
                                    >
                                      {
                                        pensionnomineeError[
                                          `date_of_exit_${index}`
                                        ]?.message
                                      }
                                    </p>
                                  )}
                                </div>
                                <div className="form-group col-md-4 form-builder-element mb-3">
                                  <label htmlFor="">
                                    Scheme Certificate (if issued)
                                  </label>
                                  <input
                                    className="form-control form-view"
                                    type="text"
                                    disabled={filledForm?.formStatusByHR}
                                    name="scheme_certificate"
                                    onChange={(e) =>
                                      handleChangePensionNominee(e, index)
                                    }
                                    style={{
                                      ...(error?.nominee_guardian_name_address
                                        ? { border: "1px solid red" }
                                        : {}),
                                    }}
                                    value={nomineepen?.scheme_certificate}
                                  />
                                </div>
                                <div className="form-group col-md-4 form-builder-element mb-3">
                                  <label htmlFor="">
                                    Non Contributory Period (NCP) Days
                                  </label>
                                  <input
                                    className="form-control form-view"
                                    type="number"
                                    disabled={filledForm?.formStatusByHR}
                                    name="ncp_days"
                                    onChange={(e) =>
                                      handleChangePensionNominee(e, index)
                                    }
                                    style={{
                                      ...(error?.ncp_days
                                        ? { border: "1px solid red" }
                                        : {}),
                                    }}
                                    value={nomineepen?.ncp_days}
                                  />
                                </div>
                                <div className=" col-md-4 d-none d-md-block"></div>
                                {[
                                  ...pensionnominees.filter(
                                    (nom) => nom !== null
                                  ),
                                ].length < 5 &&
                                  another_row ===
                                    [
                                      ...pensionnominees.filter(
                                        (nom) => nom !== null
                                      ),
                                    ].length && (
                                    <div className="col-md-4 d-flex justify-content-end align-items-center">
                                      <button
                                        className={`btn ${"btn-primary"} ml-4`}
                                        onClick={pensionaddMore}
                                      >
                                        <span className="pr-2">
                                          <i
                                            className="fa fa-plus"
                                            aria-hidden="true"
                                          ></i>
                                        </span>
                                        Add More
                                      </button>
                                    </div>
                                  )}
                              </div>
                            </div>
                          </Card>
                        );
                      }
                    })}
                  </div>
                </div>
              </>
            )}
            <div className="row">
              <div className="col-12 d-flex justify-content-center mt-4">
                <button
                  className={`btn ${
                    validateInput() ||
                    ((formData?.provident_fund_scheme === "yes" ||
                      formData?.pension_scheme === "yes") &&
                      (((formData?.provident_fund_scheme === "yes" ||
                        formData?.pension_scheme === "yes") &&
                        unexempted === "yes" &&
                        validateNominee()) ||
                        ((formData?.provident_fund_scheme === "yes" ||
                          formData?.pension_scheme === "yes") &&
                          exempted === "yes" &&
                          validatePensionNominee()))) ||
                    (formData?.provident_fund_scheme === "yes" ||
                    formData?.pension_scheme === "yes"
                      ? !(exempted === "yes" || unexempted === "yes")
                      : false) ||
                    filledForm?.formStatusByHR ||
                    IS_DISABLE
                      ? "btn-secondary"
                      : "btn-primary"
                  } `}
                  onClick={handleSubmit}
                  disabled={
                    validateInput() ||
                    ((formData?.provident_fund_scheme === "yes" ||
                      formData?.pension_scheme === "yes") &&
                      (((formData?.provident_fund_scheme === "yes" ||
                        formData?.pension_scheme === "yes") &&
                        unexempted === "yes" &&
                        validateNominee()) ||
                        ((formData?.provident_fund_scheme === "yes" ||
                          formData?.pension_scheme === "yes") &&
                          exempted === "yes" &&
                          validatePensionNominee()))) ||
                    (formData?.provident_fund_scheme === "yes" ||
                    formData?.pension_scheme === "yes"
                      ? !(exempted === "yes" || unexempted === "yes")
                      : false) ||
                    filledForm?.formStatusByHR ||
                    IS_DISABLE
                  }
                >
                  <span className="pr-2">
                    <i className="fa fa-paper-plane" aria-hidden="true"></i>
                  </span>
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Card>
  );
}

export default Form11;
